(() => {
  if (window.funtekReferencePricing) return;
  window.funtekReferencePricing = true;
  // A size with one supported thickness must not retain the old size's price.
  document.addEventListener('change', event => {
    const input = event.target;
    const picker = input.closest?.('variant-radios');
    if (!picker) return;
    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
    if (!fieldsets[0]?.contains(input)) return;
    const data = picker.querySelector('script[type="application/json"]');
    const thickness = fieldsets[1]?.querySelector('input:checked');
    if (!data || !thickness) return;
    const variants = JSON.parse(data.textContent);
    if (variants.some(v => v.option1 === input.value && v.option2 === thickness.value)) return;
    const matches = variants.filter(v => v.option1 === input.value);
    const fallback = matches.find(v => v.available) || matches[0];
    const next = fallback && Array.from(fieldsets[1].querySelectorAll('input')).find(node => node.value === fallback.option2);
    if (next) { next.disabled = false; next.checked = true; }
  }, true);
  function update(variant, sectionId) {
    document.querySelectorAll('[data-funtek-commercial]').forEach(panel => {
      if (sectionId && !panel.closest(`#shopify-section-${CSS.escape(sectionId)}`)) return;
      const variants = JSON.parse(panel.querySelector('[data-funtek-pricing-variants]').textContent);
      if (!variant || !variants.some(item => item.id === variant.id)) return;
      const size = String(variant.option1).match(/(\d+)\s*[x×]\s*(\d+)/i);
      if (!size) return;
      const area = Number(size[1]) * Number(size[2]) / 1000000;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      panel.querySelector('[data-funtek-unit-price]').textContent = money.format(variant.price / 100);
      panel.querySelector('[data-funtek-slab-price]').textContent = money.format(variant.price * area / 100);
      panel.querySelector('[data-funtek-slab-area]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {maximumFractionDigits: 4}).format(area);
      panel.querySelector('[data-funtek-selected-spec]').textContent = variant.title;
    });
  }
  document.addEventListener('variant:change', event => update(event.detail.variant, event.detail.sectionId));
})();
